import React from 'react';
import Portal from 'react-portal';
import bowser from 'bowser';
import styles from './StarBlock.css';
import { variables } from '../../../config/postcss.config';
import ExpandButton from '../ExpandButton';

const handleExpandToggle = onExpand => () => {
  if (window.innerWidth <= variables.variables.mobile || bowser.tablet) {
    onExpand();
  }
};

const StarBlock = ({ pic, name, info, isExpand, onExpand, className, isEng, isCenter }) => (
  <div
    className={`${styles.starBlock} ${isExpand ? styles.isExpand : ''} ${className}`}
    onClick={handleExpandToggle(onExpand)}
    data-ga-on={!isExpand && 'click'}
    data-ga-event-category="Stars"
    data-ga-event-action={name}
  >
    <div className={`${styles.cover} ${pic ? '' : styles.noImg}`}>
      <div className={styles.img} style={{ backgroundImage: `url(${pic})` }} />
      {info ? (
        <ExpandButton
          className={styles.expandBtn}
          isExpand={isExpand}
          onClick={(e) => {
            e.stopPropagation();
            onExpand();
          }}
        />
      ) : null}
      <div className={styles.info}>
      {info.split('\n').map((i, v) => <div key={v}>{i}</div>)}
      </div>
    </div>
    <div>
      <div className={`${styles.name} ${isEng ? styles.isEng : ''}`}>{name}</div>
    </div>

    <Portal isOpened={window.innerWidth <= variables.variables.mobile && isExpand}>
      <div className={styles.mobileInfo} onTouchMove={e => e.preventDefault()} onClick={handleExpandToggle(onExpand)}>
        <ExpandButton
          className={styles.mobileExpandButton}
          onClick={(e) => {
            e.stopPropagation();
            onExpand();
          }}
          isExpand
        />
        <div className={styles.info}>
          <div className={`${styles.bgImg} ${isCenter ? styles.isCenter : ''}`} style={{ backgroundImage: `url(${pic})` }} />
          <div className={styles.p}>
            <div className={`${styles.name} ${isEng ? styles.isEng : ''}`}>{name}</div>
            {info.split('\n').map((i, v) => <div key={v}>{i}</div>)}
          </div>
        </div>
      </div>
    </Portal>
  </div>
);

export default StarBlock;



// WEBPACK FOOTER //
// ./src/components/StarBlock/index.js